import * as React from "react"
import type { SVGProps } from "react"
const SvgOpenFullScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21a1 1 0 0 1-.71-.29A1 1 0 0 1 3 20v-6q0-.42.29-.71.29-.3.71-.29.42 0 .71.29.3.29.29.71v3.6L17.6 5H14a1 1 0 0 1-.71-.29A1 1 0 0 1 13 4q0-.42.29-.71.29-.3.71-.29h6q.42 0 .71.29.3.29.29.71v6q0 .42-.29.71-.29.3-.71.29a1 1 0 0 1-.71-.29A1 1 0 0 1 19 10V6.4L6.4 19H10q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29z" />
  </svg>
)
export default SvgOpenFullScreen
